import HttpService from "./htttp.service";

class ClientService {
  /**
   * Lista todos os clientes do usuário logado
   */
  getClients = async () => {
    return await HttpService.get("clients");
  };

  /**
   * Busca um cliente específico
   */
  getClient = async (id) => {
    return await HttpService.get(`clients/${id}`);
  };

  /**
   * Cria um novo cliente
   */
  createClient = async (payload) => {
    const response = await HttpService.post("clients", payload);
    if (response && typeof response === 'object' && !response.data) {
      return { ...response, data: response };
    }
    return response;
  };

  create = async (payload) => {
    return await this.createClient(payload);
  };

  /**
   * Atualiza um cliente
   */
  updateClient = async (id, payload) => {
    let response = await HttpService.patch(`clients/${id}`, payload);

    // Se a resposta for vazia (ex: 204 No Content), buscamos o cliente atualizado para não quebrar o estado
    if (!response) {
      response = await this.getClient(id);
    }

    // Garante compatibilidade com Context que espera .data (se a API retornar o objeto direto)
    if (response && typeof response === 'object' && !response.data) {
      return { ...response, data: response };
    }
    return response;
  };

  update = async (id, payload) => {
    return await this.updateClient(id, payload);
  };

  /**
   * Remove um cliente
   */
  deleteClient = async (id) => {
    return await HttpService.delete(`clients/${id}`);
  };

  delete = async (id) => {
    return await this.deleteClient(id);
  };
}

export default new ClientService();
